import angular from 'angular';
import uiRouter from 'angular-ui-router';
import financeEditComponent from './financeEdit.component';
import ContactInfo from './contactInfo/contactInfo';
import FinanceVehicleInfo from './financeVehicleInfo/financeVehicleInfo';
import PriceBreakdown from './priceBreakdown/priceBreakdown';
import FinanceQuotes from './financeQuotes/financeQuotes';
import FinanceConclude from './financeConclude/financeConclude';

let financeEditModule = angular.module('financeEdit', [
  uiRouter,
  ContactInfo,
  FinanceVehicleInfo,
  FinanceQuotes,
  PriceBreakdown,
  FinanceConclude
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

    $stateProvider
      .state('financeEdit', {
        url: '/finance/edit/:financeId',
        component: 'financeEdit',
        params: {
          activeTab: null
        }
      });
})

.component('financeEdit', financeEditComponent)

.name;

export default financeEditModule;



// WEBPACK FOOTER //
// ./client/app/components/finance/financeEdit/financeEdit.js